import type { ComponentPropsWithRef } from 'react'

import AutosizeTextarea from 'react-textarea-autosize'
import styled from 'styled-components'

import { stylesFrom } from '@subaio/components'

import { InputComponent } from '../Shared'

type Props = ComponentPropsWithRef<typeof AutosizeTextarea> & {
	hasError: boolean
	shouldFill?: boolean
	shouldShrink?: boolean
	minRows: number
	maxRows: number
}

export const Textarea = styled(AutosizeTextarea)<Props>`
	${stylesFrom(InputComponent)}

	min-height: unset;
	height: unset;
	resize: none;
	scrollbar-width: thin;
`
